export enum InProductTrialTypeEnum {
  NextGen = 1,
  Atd = 2,
  XdrFull = 3,
  XdrSensors = 4,
  PatchManagement = 5,
  VolumeEncryption = 6,
  MobileSecurity = 7,
  IntegrityMonitor = 8,
  StorageProtection = 9,
  ContainerProtection = 10,
  MdrEnterprise = 11,
  Cws = 12,
  ThreatIntel = 13,
  OfficeSecurityPack = 14,
  NextGenWithReconfigurePopup = 15,
  NadAndEraAddon = 16,
  WebAccessAndDeviceControlAddon = 17,
  ComplianceManager = 18,
}
